import { fetchPaxsGroup, fetchPax, updateLeadPhoneNumber, updatePaxsPhone } from '@/api/passenger'
import { fetchServices } from '@/api/service'
const getPaxsGroup = (context) => {
  fetchPaxsGroup().then((response) => {
    context.commit('PAXSGROUP_UPDATED', response)
  })
}

const getDataPaxLeader = (context) => {
  fetchPax().then((responseLead) => {
    var leadID = responseLead.paxLeadId
    fetchPaxsGroup().then((response) => {
      var dataLeadID = _.find(response, { passenger_id: leadID })
      context.commit('DATAPAXLEADER_UPDATED', dataLeadID)
    })
  })
}

const updatePhoneNumber = (context, payload) => {
  return updateLeadPhoneNumber(payload).then((response) => {
    return response
  })
}

const checkPassengerService = (context) => {
  fetchServices().then((response) => {
    context.commit('CHECK_PASSENGER_SERVICE', _.find(response, { service_id: 1 }))
  })
}

const updatePassengersPhone = (context, payload) => {
  return updatePaxsPhone(payload).then((response) => {
    return response
  })
}

export default {
  getPaxsGroup,
  getDataPaxLeader,
  updatePhoneNumber,
  checkPassengerService,
  updatePassengersPhone
}
